import API from "@/app/api";
import { DataForRZP } from "./interface";
import { track, setUserProperties, getStoredUTMs } from "./tracking";

interface RazorpayResponse {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
}

export function rzploadScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    const rzpScript = document.createElement("script");
    rzpScript.src = "https://checkout.razorpay.com/v1/checkout.js";
    rzpScript.crossOrigin = "anonymous";
    rzpScript.type = "application/javascript";
    rzpScript.async = true;

    rzpScript.onload = () => {
      resolve();
    };

    rzpScript.onerror = () => {
      reject(new Error("Razorpay SDK failed to load"));
    };

    document.body.appendChild(rzpScript);
  });
}

export const deinitializePayments = async () => {
  const razorpayScript = document.querySelector(
    `script[src="https://checkout.razorpay.com/v1/checkout.js"]`
  );
  if (razorpayScript) document.body.removeChild(razorpayScript);
};

export const makeRzpPayment = async (data: DataForRZP) => {
  try {
    await rzploadScript();

    const options = {
      key: process.env.NEXT_PUBLIC_RAZORPAY_API_KEY,
      amount: data.amount,
      currency: "INR",
      name: "RideNGo",
      description: "RideNGo Booking",
      image: "/assets/icons/logo.png",
      order_id: data.rzpId,
      handler: async function (response: RazorpayResponse) {
        try {
          const razorpayConfirmation = await API.user.RazorpayConfirmation({
            order_id: response.razorpay_order_id,
            payment_id: response.razorpay_payment_id,
            signature: response.razorpay_signature,
          });
          if (!API.validators.checkSuccessCode(razorpayConfirmation)) {
            console.error("Technical error");
            // Reset loading state on payment confirmation error
            window.dispatchEvent(new CustomEvent('paymentModalDismissed'));
            return;
          }
          const razorpayConfirmationResponse = razorpayConfirmation.data.data;
          if(razorpayConfirmationResponse.isPaymentDone ){
            const txnId = response.razorpay_payment_id || response.razorpay_order_id || data.orderId;
            const alreadyTracked = sessionStorage.getItem(`rng_purchase_${txnId}`);
            if (!alreadyTracked) {
              sessionStorage.setItem(`rng_purchase_${txnId}`, 'true');
              track('purchase', {
                transaction_id: txnId,
                value: data.amount ? data.amount / 100 : 0,
                currency: 'INR',
                vehicle_name: '',
                brand: '',
                hub: '',
                city: '',
                payment_type: '',
                duration_days: 0,
                deposit: 0,
                ...getStoredUTMs(),
              });
              setUserProperties({
                is_customer: true,
              });
            }
            window.location.href= `${window.location.origin}/thank-you?userId=${razorpayConfirmationResponse.userId}`
          } else {
            // Reset loading state if payment is not done
            window.dispatchEvent(new CustomEvent('paymentModalDismissed'));
          }
        } catch (error) {
          console.error("Error confirming payment:", error);
          // Reset loading state on error
          window.dispatchEvent(new CustomEvent('paymentModalDismissed'));
        }
        // /payment/webhook/razorpay-confirmation
        //  window.location.href= `${window.location.origin}/thank-you?id=${data.orderId}`
      },
      modal: {
        ondismiss: function() {
          // Reset loading state when payment modal is dismissed/cancelled
          // We need to access the setIsLoading function from the context
          // This will be handled by the PaymentPage component
          window.dispatchEvent(new CustomEvent('paymentModalDismissed'));
        }
      },
      prefill: {
        name: data?.profileData?.name,
        email: data?.profileData?.email,
        contact: data?.profileData?.mobile,
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  } catch (error) {
    console.error("Failed to initialize Razorpay:", error);
    // Reset loading state on initialization error
    window.dispatchEvent(new CustomEvent('paymentModalDismissed'));
  }
};
